export interface TocMajorVersionDescription {
  tocMajorVersion: number;
  description: string;
}

/**
 * Type guard that asserts whether a value conforms to the TocMajorVersionDescription shape.
 *
 * @param obj - The object to check
 * @returns - boolean
 */
export const isTocMajorVersionDescription = (obj: unknown): obj is TocMajorVersionDescription => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist
  const chkObj = obj as TocMajorVersionDescription;
  if (typeof chkObj.tocMajorVersion !== "number") return false;
  if (typeof chkObj.description !== "string") return false;
  // Everything is good
  return true;
};
